"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.services = void 0;
const QuestionnaireInputToRequestTransformer_1 = require("./Transformer/QuestionnaireInputToRequestTransformer");
const ValidationCriteria_1 = require("./Util/Validation/ValidationCriteria");
const Validator_1 = require("./Util/Validation/Validator");
const FormHandlerPluginProvider_1 = require("./PluginType/FormHandler/FormHandlerPluginProvider");
const RepositoryFactory_1 = require("./Factory/RepositoryFactory");
const CustomerToDataTransformer_1 = require("./Transformer/CustomerToDataTransformer");
const ValuationToDataTransformer_1 = require("./Transformer/ValuationToDataTransformer");
const ValuationDataToDataTransformer_1 = require("./Transformer/ValuationDataToDataTransformer");
const TemplateToDataTransformer_1 = require("./Transformer/TemplateToDataTransformer");
const CustomerToInputTransformer_1 = require("./Transformer/CustomerToInputTransformer");
const VehicleToDataTransfomer_1 = require("./Transformer/VehicleToDataTransfomer");
const AxiosErrorResponseToEndpointErrorTransformer_1 = require("./Transformer/AxiosErrorResponseToEndpointErrorTransformer");
const CustomerToConfigTransformer_1 = require("./Transformer/CustomerToConfigTransformer");
const QuestionAnswerOptionToDataTransformer_1 = require("./Transformer/QuestionAnswerOptionToDataTransformer");
const QuestionToDataTransformer_1 = require("./Transformer/QuestionToDataTransformer");
const QuestionnaireToDataTransformer_1 = require("./Transformer/QuestionnaireToDataTransformer");
const VehicleCollectionToDataTransformer_1 = require("./Transformer/VehicleCollectionToDataTransformer");
const VehicleOptionToDataTransformer_1 = require("./Transformer/VehicleOptionToDataTransformer");
const AnsweredQuestionnaireToDataTransformer_1 = require("./Transformer/AnsweredQuestionnaireToDataTransformer");
const AnsweredQuestionToDataTransformer_1 = require("./Transformer/AnsweredQuestionToDataTransformer");
const FormValuesToObjectTransformer_1 = require("./Transformer/FormValuesToObjectTransformer");
const QuestionnaireToValidationMappingTransformer_1 = require("./Transformer/QuestionnaireToValidationMappingTransformer");
const ReturnLinkService_1 = require("./Service/ReturnLinkService");
const DomHelper_1 = require("./Util/DomHelper");
const Cookie_1 = require("./Util/Cookie");
const ValuationPriceExtractor_1 = require("./Service/ValuationPriceExtractor");
const DateFormatter_1 = require("./Util/DateFormatter");
const DealerToDataTransformer_1 = require("./Transformer/DealerToDataTransformer");
const FormExtensionPluginProvider_1 = require("./PluginType/FormExtension/FormExtensionPluginProvider");
const FormValidatorFactory_1 = require("./Factory/FormValidatorFactory");
const FormValidationRendererFactory_1 = require("./Factory/FormValidationRendererFactory");
const CustomerMergePatchConverter_1 = require("./Converter/CustomerMergePatchConverter");
const MergePatchConverter_1 = require("./Converter/MergePatchConverter");
const AnsweredQuestionnaireExtractor_1 = require("./Service/AnsweredQuestionnaireExtractor");
const ApiFactory_1 = require("./Factory/ApiFactory");
const NumberFormatter_1 = require("./Util/NumberFormatter");
const RMBHelper_1 = require("./Util/RMBHelper");
exports.services = {
    'factory.repository': {
        'class': RepositoryFactory_1.default,
        argumentList: [
            '@factory.container_aware'
        ]
    },
    'factory.api': {
        'class': ApiFactory_1.default,
        argumentList: [
            '@factory.container_aware'
        ]
    },
    'validation_criteria': {
        'class': ValidationCriteria_1.ValidationCriteria
    },
    'return_link': {
        'class': ReturnLinkService_1.ReturnLinkService
    },
    'validator': {
        'class': Validator_1.ValidationService,
        'argumentList': [
            '@validation_criteria'
        ],
    },
    'transformer.template_to_data': {
        'class': TemplateToDataTransformer_1.TemplateToDataTransformer
    },
    'transformer.customer_to_data': {
        'class': CustomerToDataTransformer_1.CustomerToDataTransformer
    },
    'transformer.customer_to_input': {
        'class': CustomerToInputTransformer_1.CustomerToInputTransformer
    },
    'transformer.customer_to_config': {
        class: CustomerToConfigTransformer_1.CustomerToConfigTransformer,
    },
    'transformer.vehicle_to_data': {
        class: VehicleToDataTransfomer_1.VehicleToDataTransfomer,
    },
    'transformer.vehicle_collection_to_data': {
        class: VehicleCollectionToDataTransformer_1.VehicleCollectionToDataTransformer,
        argumentList: [
            "@transformer.vehicle_to_data"
        ]
    },
    'transformer.valuation_data_to_data': {
        class: ValuationDataToDataTransformer_1.ValuationDataToDataTransformer,
        argumentList: []
    },
    'transformer.valuation_to_data': {
        class: ValuationToDataTransformer_1.ValuationToDataTransformer,
        argumentList: [
            "@transformer.customer_to_data",
            "@transformer.vehicle_to_data",
            "@transformer.answered_questionnaire_to_data",
            "@transformer.dealer_to_data",
            "@valuation.price_extractor",
            "@transformer.valuation_data_to_data"
        ]
    },
    'transformer.question_answer_to_data': {
        class: QuestionAnswerOptionToDataTransformer_1.default,
    },
    'transformer.question_to_data': {
        class: QuestionToDataTransformer_1.default,
        argumentList: [
            '@transformer.question_answer_to_data'
        ]
    },
    'transformer.questionnaire_to_data': {
        class: QuestionnaireToDataTransformer_1.default,
        argumentList: [
            '@transformer.question_to_data'
        ]
    },
    'transformer.vehicle_option_to_data': {
        class: VehicleOptionToDataTransformer_1.VehicleOptionToDataTransformer,
    },
    'transformer.dealer_to_data': {
        class: DealerToDataTransformer_1.default,
    },
    'transformer.answered_question_to_data': {
        class: AnsweredQuestionToDataTransformer_1.default,
        argumentList: [
            '@transformer.question_answer_to_data',
            '@formatter_number'
        ]
    },
    'transformer.answered_questionnaire_to_data': {
        class: AnsweredQuestionnaireToDataTransformer_1.default,
        argumentList: [
            '@transformer.answered_question_to_data'
        ]
    },
    'transformer.axios_to_error': {
        'class': AxiosErrorResponseToEndpointErrorTransformer_1.default
    },
    'transformer.form_values_to_object': {
        class: FormValuesToObjectTransformer_1.default,
    },
    'transformer.questionnaire_to_validation_mapping': {
        class: QuestionnaireToValidationMappingTransformer_1.default,
    },
    'converter.customer_merge_patch': {
        class: CustomerMergePatchConverter_1.default,
    },
    'converter.merge_patch': {
        class: MergePatchConverter_1.default,
    },
    'plugin.provider.form_handler': {
        class: FormHandlerPluginProvider_1.default,
        tags: { plugin_manager: { type: "form_handler" } },
        argumentList: [
            "@plugin.provider.form_extension"
        ],
        parent: "plugin.manager.default"
    },
    'dom_helper': {
        class: DomHelper_1.default
    },
    'valuation.price_extractor': {
        class: ValuationPriceExtractor_1.default,
    },
    'valuation.answer_extractor': {
        class: AnsweredQuestionnaireExtractor_1.default,
    },
    'formatter.date': {
        class: DateFormatter_1.default,
    },
    'cookie': {
        class: Cookie_1.default
    },
    'plugin.provider.form_extension': {
        class: FormExtensionPluginProvider_1.default,
        tags: { plugin_manager: { type: "form_extension" } },
        parent: "plugin.manager.default"
    },
    'factory.form_validator': {
        class: FormValidatorFactory_1.default,
        argumentList: ["@factory.container_aware"]
    },
    'factory.form_validation_renderer': {
        class: FormValidationRendererFactory_1.default,
        argumentList: ["@factory.container_aware"]
    },
    'transformer.questionnaire_input_to_request': {
        class: QuestionnaireInputToRequestTransformer_1.QuestionnaireInputToRequestTransformer,
        argumentList: ['@formatter.date']
    },
    'formatter_number': {
        class: NumberFormatter_1.default
    },
    'rmb_helper': {
        class: RMBHelper_1.default
    },
};
